import { jsx as i, jsxs as t } from "react/jsx-runtime";
import { VideoPlayerDefault as g } from "./components/VideoPlayerDefault/VideoPlayerDefault.mjs";
import { useState as y, useRef as N, useEffect as v } from "react";
import { fetchBrightcoveData as _, getVideoResourceUrl as x } from "./lib/fetchBrightcoveData.mjs";
import { formatText as l, formatTime as I } from "./lib/formatters.mjs";
import { VideoThumbnail as h } from "./components/VideoThumbnail/VideoThumbnail.mjs";
import { VideoPlayerProvider as S } from "./components/VideoPlayer/VideoPlayerProvider.mjs";
/* empty css                                                  */
import a from "xss";
const T = ({
  accountId: n,
  policyKey: r,
  playlistId: d,
  testId: f,
  previewOnly: o = !1
}) => {
  const [s, V] = y([]), [P, p] = y(null), c = N(!1);
  if (v(() => {
    c.current || (c.current = !0, _(
      n,
      r,
      x(void 0, d)
    ).then((e) => {
      e.videos && V(e.videos);
    }).catch((e) => console.error("VideoPlayerInline fetch error", e)));
  }, [n, r, d]), s.length === 0) return null;
  const m = (e) => {
    o || p(e);
  };
  return /* @__PURE__ */ i(S, { children: /* @__PURE__ */ i("div", { className: "VideoPlayerInline", "data-testid": f || void 0, children: s.map((e) => {
    const u = P === e.id;
    return /* @__PURE__ */ i(
      "div",
      {
        className: `VideoPlayerInline-item${u ? " VideoPlayerInline-item--active" : ""}`,
        children: u ? /* @__PURE__ */ t("div", { className: "VideoPlayerInline-playerWrapper", children: [
          /* @__PURE__ */ i(
            C,
            {
              accountId: n,
              policyKey: r,
              videoId: e.id,
              autoplay: !0,
              deferLoad: !1
            }
          ),
          /* @__PURE__ */ t("div", { className: "VideoPlayerInline-activeContent Content Content--open", children: [
            e.name && /* @__PURE__ */ i(
              "h4",
              {
                className: "VideoPlayerInline-heading u-textSecondary u-textSizeMsrp4",
                dangerouslySetInnerHTML: {
                  __html: a(l(e.name))
                }
              }
            ),
            e.long_description && /* @__PURE__ */ t("p", { className: "VideoPlayerInline-description", children: [
              /* @__PURE__ */ i(
                "span",
                {
                  dangerouslySetInnerHTML: {
                    __html: a(l(e.long_description))
                  }
                }
              ),
              " ",
              /* @__PURE__ */ i("span", { className: "VideoPlayerInline-duration", children: I(e.duration) })
            ] })
          ] })
        ] }) : /* @__PURE__ */ t("div", { className: "VideoPlayerInline-row", children: [
          /* @__PURE__ */ i("div", { className: "VideoPlayerInline-thumbnail", children: /* @__PURE__ */ i(
            h,
            {
              accountId: n,
              policyKey: r,
              videoId: e.id,
              posterUrl: e.poster,
              onActivate: () => m(e.id),
              previewOnly: o
            }
          ) }),
          /* @__PURE__ */ t(
            "div",
            {
              className: "VideoPlayerInline-content Content Content--open",
              onClick: () => m(e.id),
              role: "presentation",
              children: [
                e.name && /* @__PURE__ */ i(
                  "h4",
                  {
                    className: "VideoPlayerInline-heading u-textSecondary u-textSizeMsrp4",
                    dangerouslySetInnerHTML: {
                      __html: a(l(e.name))
                    }
                  }
                ),
                e.long_description && /* @__PURE__ */ t("p", { className: "VideoPlayerInline-description", children: [
                  /* @__PURE__ */ i(
                    "span",
                    {
                      dangerouslySetInnerHTML: {
                        __html: a(l(e.long_description))
                      }
                    }
                  ),
                  " ",
                  /* @__PURE__ */ i("span", { className: "VideoPlayerInline-duration", children: I(e.duration) })
                ] })
              ]
            }
          )
        ] })
      },
      e.id
    );
  }) }) });
}, C = (n) => n.inline && n.playlistId ? /* @__PURE__ */ i(
  T,
  {
    accountId: n.accountId,
    policyKey: n.policyKey,
    playlistId: n.playlistId,
    testId: n.testId,
    previewOnly: n.previewOnly
  }
) : n.previewOnly ? /* @__PURE__ */ i(
  h,
  {
    accountId: n.accountId,
    policyKey: n.policyKey,
    playlistId: n.playlistId,
    videoId: n.videoId,
    testId: n.testId,
    previewOnly: !0
  }
) : /* @__PURE__ */ i(g, { ...n });
export {
  C as V,
  T as a
};
//# sourceMappingURL=VideoPlayer-B3iHlG0_.mjs.map
